/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import { isNone } from '@ember/utils';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { MessageDisplay } from 'cio/app-models/in-app/in-app-message';
import {
  InAppMessageConfig,
  InAppMessageDeliveryPriority,
  InAppMessageExpiration,
  InAppPageRule,
  InAppMessageConfigUpdate,
} from 'cio/utils/in-app/message-config';

interface ConfigArgs {
  config: InAppMessageConfig;
  recipient: string;
  onChange: (config: InAppMessageConfigUpdate) => unknown;
  onRecipientChange: (recipient: string) => unknown;
  hasReadOnlyPermission: boolean;
}

export default class Config extends Component<ConfigArgs> {
  @tracked isCustomizingRecipient = false;

  @action
  onCustomizingRecipient(isCustomizing: boolean) {
    this.isCustomizingRecipient = isCustomizing;
  }

  @action
  setExpiration(expiration: InAppMessageExpiration, isAbsoluteDateSelectedOnDifferentTz?: boolean) {
    let { config } = this.args;
    this.args.onChange({
      ...config,
      expiration,
      options: {
        isAbsoluteDateSelectedOnDifferentTz,
      },
    });
  }

  @action
  setRecipient(recipient: string) {
    this.args.onRecipientChange(recipient);
  }

  @action
  setDisplay(display: MessageDisplay) {
    let { config } = this.args;
    this.args.onChange({
      ...config,
      display,
    });
  }

  @action
  setPriority(priority: InAppMessageDeliveryPriority) {
    let { config } = this.args;
    this.args.onChange({
      ...config,
      priority,
    });
  }

  @action
  setPageRules(rules: InAppPageRule[]) {
    let { config } = this.args;
    this.args.onChange({
      ...config,
      routeRules: isNone(rules) ? [] : rules,
    });
  }

  @action
  setPersistent(checkboxValue: boolean) {
    let { config } = this.args;
    this.args.onChange({
      ...config,
      persistent: checkboxValue,
    });
  }
}
